/**
 * @param {import("@knitiv/api-client-javascript").AlgoGetInfoOutput['result']} algo
 */
export const algoResolve = algo => {
	/** @type {import("@knitiv/api-client-javascript").AlgoGetInfoOutput['result']} */
	const result = {
		functions: {},
		modification: algo.modification,
		version: algo.version,
	};

	/** @type {import("@knitiv/api-client-javascript").AlgoGetInfoOutput['result']['functions']} */
	const functions = {};

	for (const [name, data] of Object.entries(algo.functions)) {
		if (typeof data === 'string') {
			const alias = data.slice(1);
			functions[name] = algo.functions[alias];
		}
		else {
			functions[name] = data;
		}
	}

	result.functions = functions;

	return result;
};
